import { render } from "./Neuralpay.vue?vue&type=template&id=a9355a48"
import script from "./Neuralpay.vue?vue&type=script&lang=js"
export * from "./Neuralpay.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__